export var SummaryCardVariants;
(function (SummaryCardVariants) {
    SummaryCardVariants["CARD"] = "CARD";
    SummaryCardVariants["ACCOUNT"] = "ACCOUNT";
    SummaryCardVariants["LOANS"] = "LOANS";
    SummaryCardVariants["DEPOSITS"] = "DEPOSITS";
    SummaryCardVariants["COMMERCIAL"] = "COMMERCIAL";
})(SummaryCardVariants || (SummaryCardVariants = {}));
export var SummaryCardStates;
(function (SummaryCardStates) {
    SummaryCardStates["DEFAULT"] = "DEFAULT";
    SummaryCardStates["DISABLED"] = "DISABLED";
})(SummaryCardStates || (SummaryCardStates = {}));
//# sourceMappingURL=summaryCardTheme.js.map